import { z } from 'zod';

import { CursorPaginationMetaSchema, PaginationSchema } from '../../../pagination.js';

export const ListNetworksQuerySchema = PaginationSchema.extend({
  active: z
    .enum(['true', 'false'])
    .optional()
    .transform((value) => (value === undefined ? undefined : value === 'true')),
  q: z.string().optional(),
});

export type ListNetworksQuery = z.infer<typeof ListNetworksQuerySchema>;

export const NetworkListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  active: z.boolean(),
  createdAt: z.string(),
});

export type NetworkListItem = z.infer<typeof NetworkListItemSchema>;

export const ListNetworksResponseSchema = z.object({
  items: z.array(NetworkListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListNetworksResponse = z.infer<typeof ListNetworksResponseSchema>;
